module.exports = __webpack_public_path__ + "img/David.de37e25f.jpg";